module.exports = __webpack_public_path__ + "static/montserrat-regular-webfont-14241bc7d0f323c655e41def3d54275d.woff";